// extracted by mini-css-extract-plugin
export var navigation = "Navigation-module--navigation--5yUZM";
export var closeButton = "Navigation-module--closeButton--47da-";
export var navigationIsExpanded = "Navigation-module--navigationIsExpanded--JVvUB";
export var link = "Navigation-module--link--KV7tt";
export var linkActive = "Navigation-module--linkActive--QVgaN";